module.exports = __webpack_public_path__ + "img/emoji_48.c33e9d25.png";